export default __webpack_public_path__ + "static/media/quotegenerator.0306a164.png";